import { UseTranslationResponse } from "react-i18next";

import { TInfoItem } from "../../models";

interface IResolveProductionProgressTitleArguments {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  t: UseTranslationResponse<any, any>["t"];
  error: TInfoItem | null | undefined;
  isFinished: boolean;
  isAborted: boolean;
  isAborting?: boolean;
}

export const resolveProductionProgressTitle = ({
  error,
  isFinished,
  isAborted,
  isAborting,
  t,
}: IResolveProductionProgressTitleArguments): string => {
  if (isFinished) {
    if (isAborted) {
      return t("rideProduction.aborted");
    }

    if (error) {
      return t("rideProduction.failed");
    }

    return t("rideProduction.finished");
  }

  if (isAborting) {
    return t("rideProduction.aborting");
  }

  return error ? t("rideProduction.aborted") : t("rideProduction.progress");
};
